import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { ChevronDown } from '../../../../web/components/svgs/icons/ChevronDown';
import { ChevronUp } from '../../../../web/components/svgs/icons/ChevronUp';
import { UpDownIcon } from '../../../../web/components/svgs/icons/UpDownIcon';
import { styleSheet } from '../styles';

export enum SortOptions {
	Demos = 'demos',
	Dials = 'dials',
	ProspectingDials = 'prospectingDials',
	Connections = 'connections',
	Points = 'points',
}

export const isSortOption = (value: string): value is SortOptions => Object.values<string>(SortOptions).includes(value);

export const displayLabels: Record<SortOptions, string> = {
	[SortOptions.Points]: 'Points',
	[SortOptions.Dials]: 'All',
	[SortOptions.ProspectingDials]: 'Prospect',
	[SortOptions.Connections]: "C's",
	[SortOptions.Demos]: 'Demos',
};

interface IProps {
	columnKey: SortOptions;
	isAsc?: boolean;
	onClickToSort: (key: SortOptions) => void;
	sortBy?: SortOptions;
}

export const ListHeader: React.FC<IProps> = ({ columnKey, isAsc, onClickToSort, sortBy }) => {
	const isSorted = sortBy === columnKey;
	const label = displayLabels[columnKey];
	const SortIcon = !isSorted ? null : isAsc ? ChevronUp : ChevronDown;
	return (
		<div className={css(styleSheet.sortHeader)} aria-sort={!isSorted ? 'none' : isAsc ? 'ascending' : 'descending'}>
			<Button
				aria-label={`Sort by ${label}`}
				size='sm'
				variant='ghost'
				styles={[styleSheet.sortButton, isSorted && styleSheet.sortButtonActive]}
				onClick={() => onClickToSort(columnKey)}
			>
				{SortIcon ? (
					<SortIcon aria-hidden='true' className={css(styleSheet.sortIcon)} />
				) : (
					<UpDownIcon fillColor='currentColor' />
				)}
				{label}
			</Button>
		</div>
	);
};
